<script lang="ts" setup>
import { computed } from 'vue'
import ChevronRightIcon from '@lahaus-roomie/roomie/src/assets/icons/chevron-right.svg'
import type { Props } from './types'
import AvatarGroup from '@/components/AvatarGroup/index.vue'

const props = defineProps<Props>()
const { t } = useI18n()

const avatars = computed(() => props.listings.map((listing) => {
  return {
    src: listing.cover,
    alt: listing.name,
    title: listing.name
  }
}))
</script>

<script lang="ts">
export default {
  name: 'ProjectListButton'
}
</script>

<template>
  <div class="flex items-center border border-carbon-600 rounded-circle p-4">
    <AvatarGroup :avatars="avatars" />

    <div class="flex-1 flex items-center justify-end text-brand-600">
      <span class="mx-4 text-14 whitespace-nowrap">
        {{ t('label') }}
      </span>

      <ChevronRightIcon class="w-24 h-24 fill-brand-600 mr-16" />
    </div>
  </div>
</template>

<i18n src="./i18n.json" />
